import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { LocalizedText } from "bernie-l10n";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelNameRatingAndAddress } from "./HotelNameRatingAndAddress";
import { UitkPriceLockup } from "uitk-react-price-lockup";
import { NearestLocationContent } from "./NearestLocation/NearestLocationContent";
import { useLocalization } from "@shared-ui/localization-context";
import { validPrice } from "components/flexComponents/Hotels/utils/isValidPrice";
import { DATE_FORMAT } from "components/flexComponents/Hotels/utils/constants";

/**
 * CardContent which contains the overall ratings, pricing, value proposition
 * and guest amount (hard coded)
 */
export const CardContentReviewsPriceProposition = ({
  hotel,
  locale,
  locationName,
  context,
  isMobile,
  isViewCarousel,
  showCheckPrices,
  showGetPriceIfNoPrice,
  showDistance,
  showAddress,
  shouldUseImperialDistanceUnits,
  addressDistanceView,
}: {
  hotel: Hotel;
  locale: string;
  locationName: string;
  context: ExtendedContextStore;
  isMobile?: boolean;
  isViewCarousel?: boolean;
  showCheckPrices?: boolean;
  showGetPriceIfNoPrice?: boolean;
  showDistance?: boolean;
  showAddress?: boolean;
  shouldUseImperialDistanceUnits?: boolean;
  addressDistanceView?: string;
}) => {
  const { formattedPrice } = hotel;
  const { formatText, formatDateString } = useLocalization();
  const checkInDateFormatted = formatDateString(hotel.isoCheckIn, { skeleton: DATE_FORMAT });
  const checkOutDateFormatted = formatDateString(hotel.isoCheckOut, { skeleton: DATE_FORMAT });
  const { isValidPrice, showGetRates } = validPrice(hotel, isMobile, showCheckPrices, showGetPriceIfNoPrice);

  return (
    <>
      {isViewCarousel ? (
        <>
          <div className="uitk-grid">
            <div className="uitk-cell fill">
              <div className="truncate uitk-type-heading-500 uitk-type-bold">{hotel.hotelName}</div>
            </div>
          </div>

          <div className="uitk-grid all-x-gutter-two">
            <div className="uitk-cell fill">
              <HotelNameRatingAndAddress
                hotel={hotel}
                locale={locale}
                context={context}
                isViewCarousel={isViewCarousel}
                showAddress={showAddress}
                showDistance={showDistance}
                locationName={locationName}
                shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
                addressDistanceView={addressDistanceView}
              />
            </div>
            {isValidPrice && (
              <UitkPriceLockup
                className="uitk-cell shrink"
                lockupPrice={formattedPrice}
                priceSubtextFirst={formatText("hotels.price.perNight")}
                priceSubtextStandard={formatText("hotels.whenBooking", checkInDateFormatted, checkOutDateFormatted)}
                a11yPrice={formatText("hotels.price.a11y", formattedPrice)}
              />
            )}
            {showGetRates && (
              <div className="uitk-cell shrink uitk-type-right">
                <div className="uitk-type-600 hotelPricing">
                  <b>
                    <LocalizedText message="hotels.price.getRates" />
                  </b>
                </div>
              </div>
            )}
            <NearestLocationContent
              context={context}
              model={hotel.directDistance}
              shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
            />
          </div>
        </>
      ) : (
        <div className="uitk-grid all-x-gutter-two">
          <div className="uitk-cell fill">
            <HotelNameRatingAndAddress
              hotel={hotel}
              locale={locale}
              context={context}
              isViewCarousel={isViewCarousel}
              showAddress={showAddress}
              showDistance={showDistance}
              locationName={locationName}
              shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
              addressDistanceView={addressDistanceView}
            />
          </div>
          {isValidPrice && (
            <UitkPriceLockup
              className="uitk-cell shrink"
              lockupPrice={formattedPrice}
              priceSubtextFirst={formatText("hotels.price.perNight")}
              priceSubtextStandard={formatText("hotels.whenBooking", checkInDateFormatted, checkOutDateFormatted)}
              a11yPrice={formatText("hotels.price.a11y", formattedPrice)}
            />
          )}
          {showGetRates && (
            <div className="uitk-cell shrink uitk-type-right">
              <div className="uitk-type-600 hotelPricing">
                <b>
                  <LocalizedText message="hotels.price.getRates" />
                </b>
              </div>
            </div>
          )}
          <NearestLocationContent
            context={context}
            model={hotel.directDistance}
            shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
          />
        </div>
      )}
    </>
  );
};
